import { UploadChangeParam, UploadFile } from "antd/es/upload";
import { useState } from "react";
import { toast } from "../lib/toast";
import { getExtension } from "../utils/string";

type Props = {
  handler: (data: FormData) => void;
  accept?: string;
  fileSize?: number;
};

export default function useUpload({ handler, fileSize = 5, accept }: Props) {
  const [filename, setFilename] = useState<string | null>(null);
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const handleUpload = (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", file.name);

    if (fileSize) {
      const MAX_FILE_SIZE = fileSize * 1024 * 1024; // MB in bytes

      if (file?.size > MAX_FILE_SIZE) {
        toast(
          "error",
          `The file size exceeds the ${fileSize}MB limit. Please upload a smaller file`
        );

        return false;
      }
    }

    if (accept && !accept?.includes(getExtension(file.name))) {
      toast(
        "error",
        `Your provided ${getExtension(file.name)} file type not allow`
      );

      return;
    }

    setFilename(file.name);

    handler(formData);
    return;
  };

  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    setFileList(info.fileList);

    if (info.file.status === "removed") {
      setFilename("No file chosen");
    }
  };

  return {
    handleUpload,
    filename,
    fileList,
    handleChange,
  };
}
